export default __webpack_public_path__ + "static/media/num-03.89835b41.svg";